<template>
  <a
    :class="color"
    :href="link"
    :target="isBlank ? '_blank' : '_self'"
    style="text-decoration: none"
  >
    {{ $t(text) }}
  </a>
</template>

<script>
export default {
  name: 'NormalLink',
  props: {
    text: {},
    link: {},
    isBlank: { default: false },
    color: { default: 'linkText--text' }
  }
}
</script>
